module.exports = __webpack_public_path__ + "img/bg_topbar_dark1.46227c0b.png";